import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { upperFirstOnly } from 'utils/format'
import classNames from 'classnames/bind'
import styles from './MetricHeader.module.scss'
import { Info } from 'components/common/info'
import { getTableCellStickyStyle } from '../../../../utils'
import { KeyPerformanceMetrics } from 'utils/constants'

const cx = classNames.bind(styles)

const MetricHeader = ({
  metric,
  periodString,
  previousColumn,
  analytics,
  headerColour,
  customColour,
  stickyConfig,
  activeTab
}) => {
  const { t } = useTranslation()
  const colour = analytics ? headerColour : metric
  const isGrey = colour === 'grey'

  return (
    <th
      className={cx('metric-header', { green: !isGrey, 'key-performance-metrics': activeTab === KeyPerformanceMetrics }, colour)}
      style={{
        ...(getTableCellStickyStyle(stickyConfig, true) || {}),
        ...(customColour ? { color: customColour } : {}),
      }}
    >
      <div>
        <div className={cx('header-title')}>
        {analytics ? metric : <span className={cx('performance-report')}> {upperFirstOnly(t(`widgets.performanceReport.${metric}`))} </span>}
        {!analytics && 
        <Info
          tooltipText={t(
            `widgets.performanceReport.${metric}Tooltip`
          )}
        />}
        </div>
        {periodString &&
          <p>{`${t('widgets.performanceReport.last')} ${periodString}`}</p>
        }
        {previousColumn && periodString &&
          <p>{`${t('widgets.performanceReport.previous')} ${periodString}`}</p>
        }
      </div>
    </th>
  )
}

MetricHeader.propTypes = {
  metric: PropTypes.string.isRequired,
  periodString: PropTypes.string,
  previousColumn: PropTypes.bool.isRequired,
  analytics: PropTypes.bool,
  headerColour: PropTypes.string,
  customColour: PropTypes.string,
  stickyConfig: PropTypes.shape({
    width: PropTypes.number,
    left: PropTypes.number,
    zIndex: PropTypes.number
  }),
  activeTab: PropTypes.string
}

MetricHeader.defaultProps = {
  stickyConfig: null,
  activeTab: null
}

export { MetricHeader }
